import * as yup from 'yup';

import { emailRequiredValidator } from '@mopla/utils';

const ForgotPasswordValidationSchema = yup.object().shape({
	email: emailRequiredValidator(),
});

export default ForgotPasswordValidationSchema;
